import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/spring-outing/2024/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/spring-outing/2024',
  name: 'activity_spring_outing_2024',
  component: Index,
  meta: {
    title: '春日漫游 打卡集章',
    expiryDate: '2024-05-07',
  },
}

export default [indexRoute]
